<template>
  <div class="modal overlay" v-if="show">
    <div class="modal__box">
      <div class="modal__box-image">
        <button class="close-notification" @click="CloseModal('close-btn')">
          <img src="../../../assets/close-notification.svg" alt />
        </button>
        <img :src="data.photo" alt />
      </div>
      <div class="modal__box-title">
        <span>Notificação do totem</span>
        <h2>Recepção Principal</h2>
      </div>
      <div class="modal__box-body">
        <h3>{{data.mensagem.nome}}</h3>
        <h5>{{data.mensagem.texto}}</h5>
      </div>
      <button type="button" @click="CloseModal('ok-btn')" class="modal__box-button">Ok</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "show"],
  methods: {
    CloseModal(origin) {
      this.$emit("close-modal-not", { origin: origin });
    }
  }
};
</script>